import request from '@/libs/request'
import { toast } from '../libs/utils'

// 领取审核中的报告
export async function receiveReport (params) {
  let data = await request.post('/order/reportAudit/claimReport', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '领取审核报告异常！'})
    return false
  }
}
// 审核报告通过
export async function reportPass (params) {
  let data = await request.post('/order/reportAudit/reportAuditPass', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '通过审核报告异常！'})
    return false
  }
}
// 审核报告驳回
export async function rejectReport (params) {
  let data = await request.post('/order/reportAudit/reportAuditNotPass', params, false)
  if (data && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '驳回审核报告异常！'})
    return false
  }
}
// 放弃审核报告
export async function giveUpReport (params) {
  let data = await request.post('/order/reportAudit/unClaimReport', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '放弃审核报告异常！'})
    return false
  }
}
// 认领报告检查
export async function receiveCheck (params) {
  let data = await request.post('/order/reportAudit/claimReportPreCheck', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '检查认领审核报告异常！'})
  }
}
